export default __webpack_public_path__ + "img/password-check.57d225fc.svg";